<template>
  <div class="footers" v-bind:style="{height: height/100+'rem'}">
    <slot></slot>
  </div>
</template>
<script>
  export default {
  	name: "appFooter",
	  props: {
		  height: {
			  type: Number
		  }
	  }
  }
</script>
<style lang="scss" scoped>
  .footers{
    height: 1.2rem;
    position: relative;
    z-index: 2;
  }
</style>


// WEBPACK FOOTER //
// src/layouts/AppFooter/index.vue